import React from 'react'
import project from '../../project'
import { Tracking } from '../../../NodeModules/nnd-track-page'
import axios from 'axios';
import Select from 'react-select'
// import BreachCodes from './BreachCodes'

import "../assets/styles/home.scss"

const apiURL_storage = 'https://news-networkeditorial.s3.ap-southeast-2.amazonaws.com/interactives/OlympicsTeamTracker/prod/OlympicsTeamTracker.json'

class Home extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      firstInteraction: false,
      data: undefined,
      daysUntil: null,
      filteredData: [],
      athletesCount: null,
      stateOptions: [
        { value: 'ACT', label: 'ACT' },
        { value: 'NSW', label: 'NSW' },
        { value: 'NT', label: 'NT' },
        { value: 'QLD', label: 'QLD' },
        { value: 'SA', label: 'SA' },
        { value: 'TAS', label: 'TAS' },
        { value: 'VIC', label: 'VIC' },
        { value: 'WA', label: 'WA' },
      ],
      sportOptions: [
        { value: 'All', label: 'All Sports' },
        { value: 'Archery', label: 'Archery' },
        { value: 'Artistic gymnastics', label: 'Artistic gymnastics' },
        { value: 'Artistic swimming', label: 'Artistic swimming' },
        { value: 'Athletics', label: 'Athletics' },
        { value: 'Badminton', label: 'Badminton' },
        { value: 'Basketball', label: 'Basketball' },
        { value: 'Basketball 3×3', label: 'Basketball 3×3' },
        { value: 'Beach volleyball', label: 'Beach volleyball' },
        { value: 'BMX freestyle', label: 'BMX freestyle' },
        { value: 'BMX racing', label: 'BMX racing' },
        { value: 'Boxing', label: 'Boxing' },
        { value: 'Breaking', label: 'Breaking' },
        { value: 'Canoe slalom', label: 'Canoe slalom' },
        { value: 'Canoe sprint', label: 'Canoe sprint' },
        { value: 'Cycling track', label: 'Cycling track' },
        { value: 'Diving', label: 'Diving' },
        { value: 'Equestrian', label: 'Equestrian' },
        { value: 'Fencing', label: 'Fencing' },
        { value: 'Football', label: 'Football' },
        { value: 'Golf', label: 'Golf' },
        { value: 'Handball', label: 'Handball' },
        { value: 'Hockey', label: 'Hockey' },
        { value: 'Judo', label: 'Judo' },
        { value: 'Marathon swimming', label: 'Marathon swimming' },
        { value: 'Modern pentathlon', label: 'Modern pentathlon' },
        { value: 'Mountain biking', label: 'Mountain biking' },
        { value: 'Rhythmic gymnastics', label: 'Rhythmic gymnastics' },
        { value: 'Road cycling', label: 'Road cycling' },
        { value: 'Rowing', label: 'Rowing' },
        { value: 'Rugby', label: 'Rugby' },
        { value: 'Sailing', label: 'Sailing' },
        { value: 'Shooting', label: 'Shooting' },
        { value: 'Skateboarding', label: 'Skateboarding' },
        { value: 'Sport climbing', label: 'Sport climbing' },
        { value: 'Surfing', label: 'Surfing' },
        { value: 'Swimming', label: 'Swimming' },
        { value: 'Table tennis', label: 'Table tennis' },
        { value: 'Taekwondo', label: 'Taekwondo' },
        { value: 'Tennis', label: 'Tennis' },
        { value: 'Trampoline', label: 'Trampoline' },
        { value: 'Triathlon', label: 'Triathlon' },
        { value: 'Volleyball', label: 'Volleyball' },
        { value: 'Water polo', label: 'Water polo' },
        { value: 'Weightlifting', label: 'Weightlifting' },
        { value: 'Wrestling', label: 'Wrestling' }
      ],
      selectedStates: [],
      selectedPos: null, // { label: "All Sports", value: "All" },
      selectedSort: 'lastname',
      selectedSortDirection: 'asc',
      preselect: null,
      activeCard: null,
      breach: null
      // domain: window.location.hostname.replace('www.','').replace('.com.au','') //  codesports
    }

    // this.loadData = this.loadData.bind(this)

    this.siteCode = this.siteCode.bind(this)
    // this.checkBreach = this.checkBreach.bind(this)
    this.loadData = this.loadData.bind(this)
    this.visChange = this.visChange.bind(this)

    const thisState = this

    let appContainer = document.getElementById(`app_${project.name}`)
    appContainer.addEventListener('mouseenter', (f) => {
      if (!thisState.state.firstInteraction) {
        thisState.state.firstInteraction = true
        Tracking.trackPageImpression('firstinteraction', project.name)
      }
    })

    this.state.preselect = appContainer.getAttribute('data-preselect')
    thisState.state.daysUntil = this.daysUntil();
    
  }

  componentDidMount () {
    // this.checkBreach()
    this.siteCode(window.location.hostname)
    this.preselectCheck()
  }

  preselectCheck () {
    // console.log('this.state.preselect', this.state.preselect)
    if (this.state.preselect) {
      const condition = sport => sport.value === this.state.preselect
      const preselectedSport = this.state.sportOptions.find(condition)

      // console.log('preselectedSport', preselectedSport)
      this.setState({
        selectedPos: preselectedSport ? preselectedSport : this.randomSport()
      }, () => {
        this.loadData()
      })
    } else {
      this.setState({
        selectedPos: this.randomSport()
      }, () => {
        this.loadData()
      })
    }
  }

  randomSport () {
    const randomIndex = Math.floor(Math.random() * this.state.sportOptions.length)
    const randomSport = this.state.sportOptions[randomIndex]
    console.log('randomSport', randomSport)
    return randomSport
  }

  visChange (isVisible) {
    // console.log('Breach is now %s', isVisible ? 'visible' : 'hidden');
    if ( isVisible && this.state.appInViewport === false) {
      this.state.appInViewport = true
      Tracking219.trackBreachImpression('app In Viewport', project.name)
    }
  }

  siteCode (siteHostname) {
    let siteCode, siteDomain
    switch (siteHostname) {

      case 'www.adelaidenow.com.au' :
        siteCode = 'adv'
        siteDomain = 'adelaidenow'
        break
      
      case 'www.cairnspost.com.au' :
        siteCode = 'cp'
        siteDomain = 'cairnspost'
        break

      case 'www.codesportssit.com.au' :
        siteCode = 'cs'
        siteDomain = 'codesports'
        break

      case 'www.codesports.com.au' :
        siteCode = 'cs'
        siteDomain = 'codesports'
        break

      case 'www.codesportsuat.com.au' :
        siteCode = 'cs'
        siteDomain = 'codesports'
        break
      
      case  'www.couriermail.com.au' :
        siteCode = 'cm'
        siteDomain = 'couriermail'
        break

      case  'www.heraldsun.com.au' :
        siteCode = 'hs'
        siteDomain = 'heraldsun'
        break
      
      case  'www.geelongadvertiser.com.au' :
        siteCode = 'ga'
        siteDomain = 'geelongadvertiser'
        break
      
      case  'www.goldcoastbulletin.com.au' :
        siteCode = 'gcb'
        siteDomain = 'goldcoastbulletin'
        break

      case  'www.ntnews.com.au' :
        siteCode = 'ntn'
        siteDomain = 'ntnews'
        break
      
      case  'www.thechronicle.com.au' :
        siteCode = 'twc'
        siteDomain = 'thechronicle'
        break

      case  'www.themercury.com.au' :
        siteCode = 'merc'
        siteDomain = 'themercury'
        break
      
      case  'www.townsvillebulletin.com.au' :
        siteCode = 'tb'
        siteDomain = 'townsvillebulletin'
        break
      
      case  'www.weeklytimesnow.com.au' :
        siteCode = 'wtn'
        siteDomain = 'weeklytimesnow'
        break
      
      case  'www.dailytelegraph.com.au' :
        siteCode = 'dt'
        siteDomain = 'dailytelegraph'
        break

      case  'www.dailytelegraphsit.com.au' :
        siteCode = 'dt'
        siteDomain = 'dailytelegraph'
        break

      case  'www.dailytelegraphuat.com.au' :
        siteCode = 'dt'
        siteDomain = 'dailytelegraph'
        break

      case 'localhost' :
        siteCode = 'dt'
        siteDomain = 'dailytelegraph'
        break
    }
    this.setState({
      siteCode: siteCode,
      siteDomain: siteDomain
    })

    return siteCode

  }

  loadData () {
    
    axios.get(apiURL_storage)
    .then((response) => {
      // console.log('response', response)
      let titlesRemoved = response.data.values
      titlesRemoved.shift()

      const cleanData = titlesRemoved.filter( card => card.length )
      const dataPaired = cleanData.map(function(player, index){
        // console.log('player', player[5])
        const newPlayer = {}
        newPlayer.id = index
        newPlayer.lastname = player[0]
        newPlayer.firstname = player[1]
        newPlayer.image = player[2] ? player[2] : 'default'
        newPlayer.state = player[3]
        newPlayer.born = player[4]
        newPlayer.hometown = player[5]
        newPlayer.sport = player[6]
        newPlayer.event = player[7]
        newPlayer.age = player[8]
        newPlayer.gender = player[9]
        newPlayer.previous = player[10]
        newPlayer.long = player[11]
        newPlayer.lat = player[12]
        newPlayer.desc = player[13]
        newPlayer.link = player[14]
        newPlayer.linkText = player[15] ? player[15] : 'More info.'

        return newPlayer
      });

      // console.log('dataPaired', dataPaired);

      const dataSorted = this.sortByKey(dataPaired, this.state.selectedSort, this.state.selectedSortDirection)

      this.setState({
        data: dataSorted,
        athletesCount: dataSorted.length
      }, function () {
        this.filterList ()
      });

    })
    .catch((err) => {
      console.log('err', err)
    })

  }

  /*
  processData () {
    
    const data = this.state.data
    // const u17Data = data.filter( card => card[1] == 'u17' )
    // const u18Data = data.filter( card => card[1] == 'u18' )

    this.setState({
      dataU17: u17Data,
      dataU18: u18Data
    }, function () {
      if ( this.state.breach === true ) {
        console.log('IS BREACH, TIME TO SLASH')
        this.dataSlash()
      }
    });

  }*/

  changeState (e) {
    // console.log('e', e);
    const states = e.map((state) => {
      return state['value']
    })
    this.setState({
      selectedStates: states
    }, () => {
      this.filterList()
    })
    
  }

  changePos (e) {
    const pos = e
    this.setState({
      selectedPos: pos
    }, () => {
      this.filterList()
    })
  }

  /*changeSort (e, sortKey) {
    // console.log('e.currentTarget', e.currentTarget)
    const activeColumn = this.state.activeColumn;
    // console.log('activeColumn', activeColumn);
    if (activeColumn) {
      activeColumn.classList.remove('activeSort');
    }
      

    this.setState({
      selectedSort: sortKey,
      activeColumn: e.currentTarget
    }, () => {
      const newDataSorting = this.sortByKey(this.state.filteredData, this.state.selectedSort, this.state.selectedSortDirection)
      this.setState({
        filteredData: newDataSorting
      })
    })

    e.currentTarget.classList.add('activeSort');
    
  }*/

  /*scrollRounds (e, direction) {
    if (direction === 'left') {
      this.refs.scroller ? (this.refs.scroller.scrollLeft -= 90) : null
    } else {
      this.refs.scroller ? (this.refs.scroller.scrollLeft += 90) : null
    }
  }*/

  daysUntil() {
    // Parse the target date string into a Date object
    const targetDate = '2024-07-26'
    const targetDateTime = new Date(targetDate)
    // Get the current date and time
    const now = new Date()
    // Calculate the time difference in milliseconds
    const timeDiff = targetDateTime - now
    // Calculate the number of days
    const days = Math.ceil(timeDiff / (1000 * 60 * 60 * 24))
  
    return days
  }
  

  filterList () {
    // console.log('time to filter')
    // console.log(this.state.selectedStates)
    // console.log(this.state.selectedPos)
    // console.log(' this.state.data',  this.state.data)

    const filteredList = this.state.data.filter((record) => {
      // console.log('record', record)
      // IF ALL states and ALL positions
      if ( this.state.selectedStates.length == 0 && this.state.selectedPos['value'] == 'All' ) {
        // console.log('IF ALL states and ALL positions');
        return record //record.stat == this.state.selectedPos['value']
      } 
      // IF ALL STATES and SOME POSITIONS
      if ( this.state.selectedStates.length == 0 && record.sport.includes(this.state.selectedPos['value']) ) {
        // console.log('IF ALL STATES and SOME POSITIONS');
        return record
      }
      // IF SOME STATES and ALL POSITIONS
      
      else if ( this.state.selectedStates.indexOf(record.state) > -1 && this.state.selectedPos['value'] == 'All') {
        // console.log('IF SOME STATES and ALL POSITIONS', record.state, this.state.selectedStates );
        return record
      } 
      // IF SOME STATES and SOME POSITIONS
      else if ( this.state.selectedStates.indexOf(record.state) > -1 && record.sport.includes(this.state.selectedPos['value']) ) {
        // console.log('IF SOME STATES and SOME POSITIONS');
        return record
      }
      
    })

    // console.log(' filteredList',  filteredList)
    // const dataSorting = this.sortByKey(filteredList, this.state.selectedSort, this.state.selectedSortDirection)

    this.setState({
      // filteredData: dataSorting
      filteredData: filteredList
    })

  }

  /* LOAD READER RANKING */
  sortByKey (array, key, ascdesc) {
    return array.sort((a, b) => {
      let x = (ascdesc === 'asc') ? b[key] : a[key]
      let y = (ascdesc === 'asc') ? a[key] : b[key]
      return -((x < y) ? -1 : ((x > y) ? 1 : 0))
    })
  }

  expandCard (e) {
        
    const targetRow = e.target.closest('.nnd-player')
    const targetSection = targetRow.querySelector('.nnd-player-content')
    const targetSectionHeight = targetSection.offsetHeight
    const targetImage = targetRow.querySelector('.nnd-player-tile')
    const targetImageHeight = targetImage.offsetHeight
    const existActiveRow = document.querySelector(".nnd-player.nnd-active")

    if ( targetRow === this.state.activeCard ) {
      targetRow.classList.toggle(`nnd-active`)
      this.setState({
        activeCard: null
      }, function () {
        targetRow.style.height = targetImageHeight + 'px'
      });

    } else {
      if (existActiveRow) {
        const existActiveRowImageHeight = existActiveRow.querySelector('.nnd-player-tile').offsetHeight
        existActiveRow.classList.toggle(`nnd-active`)
        existActiveRow.style.height = existActiveRowImageHeight + 'px'
      }

      this.setState({
        activeCard: targetRow
      }, function () {
        const currentCard =  this.state.activeCard
        currentCard.classList.toggle(`nnd-active`)
        currentCard.style.height = targetImageHeight + 'px'
        targetRow.style.height = ( targetSectionHeight + targetImageHeight )+ 'px'
      });

    }
  }

  /*closeCard () {
    console.log('closeCard')
    const existActiveRow = document.querySelector(".nnd-player.nnd-active")
    if (existActiveRow) {
      
      this.setState({
        activeCard: null
      }, function () {
        const existActiveRowImageHeight = existActiveRow.querySelector('.nnd-player-tile').offsetHeight
        existActiveRow.classList.toggle(`nnd-active`)
        existActiveRow.style.height = existActiveRowImageHeight + 'px'
      });

    }
    
  }*/

  render() {
    // const isBreached = this.state.breach
    const playerTiles = (typeof this.state.filteredData !== 'undefined') ? this.state.filteredData.map((item) => {
      // const pname = atob(item.name)
      if (typeof this.state.data !== 'undefined') {
        return (
          <div key={item.id} className={`nnd-player`} onClick={(e) => { this.expandCard(e); /*e.preventDefault()*/ }} >
            <div className='nnd-player-tile'>
              {/*<img alt={item.player} src={require(`../assets/images/${item.image}.jpg`)} />*/}
              
              <div className="nnd-cta">
                <h4 className="nnd-cta-player">
                  <div className="nnd-cta-thumb" >
                    <img className="nnd-cta-thumb-img" loading="lazy" alt={item.lastname} src={require(`../assets/images/${item.image}.jpg`)} />
                  </div>
                  <span className="nnd-cta-name">{ item.lastname }, { item.firstname }</span>
                  <span className="nnd-cta-pos">{ item.sport}</span>
                </h4>
                <div className="nnd-cta-icon" data-index={item.id}>
                  <div className="nnd-cta-icon_plus"></div>
                  <div className="nnd-cta-icon_plus_vertical"></div>
                </div>
              </div>
            </div>
            <div className='nnd-player-tile-expanded'>
              <div className="nnd-player-content">
                <div className="nnd-player-content-inner">
                  
                  <div className="nnd-player-text" >
                    <div className="nnd-details">
                      <h3>{ item.firstname } { item.lastname }</h3>
                      <h5>{ item.sport } - { item.event }</h5>
                      <p className="nopad"><span>Age:</span> { item.age }</p>
                      <p className="nopad"><span>State:</span> { item.state }</p>
                      <p className="nopad"><span>Born:</span> { item.born }</p>
                      <p className="nopad"><span>Hometown:</span> { item.hometown }</p>
                      <p className="nopad"><span>Previous Olympics:</span> { item.previous }</p>
                    </div>
                    <div className="nnd-player-image" >
                      <img className="nnd-player-image-img" loading="lazy" alt={item.lastname} src={require(`../assets/images/${item.image}.jpg`)} />
                    </div>
                  </div>
                  
                  <div className="nnd-player-text-profile">
                    <p className="nnd-desc">{ item.desc }</p>
                    <a className="nnd-player-link" href={item.link} target="_blank">{ item.linkText }</a>
                  </div>
                </div>
              </div>
            </div>
          </div>
        )
      }
    }) : ''

    // const isMobApp = this.state.isMobApp
    const siteDomain = this.state.siteDomain
    // console.log('siteDomain', siteDomain)
    const isActiveCard = this.state.activeCard

    // console.log('playerTiles', playerTiles)

    return (
      <div id="nnd-container" className={`${siteDomain ? siteDomain : ""}`}>
        <div className="nnd-header">
          <div className="nnd-header-1">
            <h3>Australian Olympic Team Tracker</h3>
            <p>Who has made the squad for Paris 2024</p>
          </div>
          <div className="nnd-header-2">
            <span className="nnd-counter">{ this.state.athletesCount }</span>
            <span className="nnd-counter-text">Selected with {this.state.daysUntil} days to go</span>
          </div>
        </div>

        <div className="nnd-navigation">
          <Select 
            onChange={event => this.changeState(event)} 
            className="nnd-state" 
            classNamePrefix="nnd-select" 
            isMulti 
            options={this.state.stateOptions} 
            placeholder={'Select a state to filter...'}
          />
              
          <Select 
            onChange={event => this.changePos(event)} 
            className="nnd-sport" 
            classNamePrefix="nnd-select" 
            options={this.state.sportOptions} 
            value={this.state.selectedPos}
          />
        </div>
        
        <div className="nnd-cont-main-wrap">
          <div className="nnd-cont-main" ref="scroller">
            <div className={isActiveCard !== null ? 'nnd-tiles nnd-activeCard' : 'nnd-tiles'} >
              {playerTiles.length
              ?
                playerTiles
              :
                <div className="nnd-tiles">
                  <div className="nnd-noTile-message">There are no athletes selected yet for this sport or state</div>
                </div>
              }
            </div>
          </div>
        </div>
      </div>
    )
  }
}

export default Home


// WEBPACK FOOTER //
// ./src/components/Home.js